// ── Gemeinsame Helfer für die Launch Phase (Warm-up) ──
// Die Launch Phase läuft über WARMUP_RAMP_DAYS Werktage (Mo–Fr); der Versand zählt
// daher in WERKTAGEN, nicht in Kalendertagen. Diese reinen Datums-/Index-Helfer
// werden sowohl im Research Center (Eingabe) als auch im Team-Dashboard (Überblick)
// genutzt – darum hier zentral, um Duplizierung zu vermeiden.

export const WARMUP_START_VOLUME = 3;
export const WARMUP_RAMP_DAYS = 20;
export const WARMUP_MS_PER_DAY = 86400000;
// Erlaubte Bandbreite fürs dauerhafte Tagesziel (still im Hintergrund begrenzt).
export const WARMUP_TARGET_MIN = 10;
export const WARMUP_TARGET_MAX = 200;
export const WARMUP_TARGET_DEFAULT = 30;

export const clampWarmupTarget = (v) => {
  const n = Math.round(Number(v) || 0);
  if (!n) return WARMUP_TARGET_DEFAULT;
  return Math.max(WARMUP_TARGET_MIN, Math.min(WARMUP_TARGET_MAX, n));
};

// Geplanter neuer Outreach am Werktag `dayIndex` (linear von WARMUP_START_VOLUME bis target).
export const warmupPlannedNew = (dayIndex, target) => {
  const t = Number(target) || 0;
  if (dayIndex < 1) return 0;
  if (dayIndex >= WARMUP_RAMP_DAYS) return t;
  const frac = (dayIndex - 1) / (WARMUP_RAMP_DAYS - 1);
  return Math.max(WARMUP_START_VOLUME, Math.round(WARMUP_START_VOLUME + (t - WARMUP_START_VOLUME) * frac));
};

// Geplante Follow-ups am Werktag `dayIndex` (Orientierung, Worst-Case ohne Antworten):
// 1. Welle = Batch von vor 1 Woche (5 Werktagen), 2. Welle = von vor 2 Wochen (10 Werktagen).
export const warmupFollowups = (dayIndex, target) => {
  const f1 = dayIndex > 5 ? warmupPlannedNew(dayIndex - 5, target) : 0;
  const f2 = dayIndex > 10 ? warmupPlannedNew(dayIndex - 10, target) : 0;
  return { f1, f2, total: f1 + f2 };
};

export const warmupStartOfDay = (ms) => { const d = new Date(ms); d.setHours(0, 0, 0, 0); return d.getTime(); };

export const warmupDateKey = (ms) => {
  const d = new Date(ms);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
};

// Wochenende (Sa/So) – an diesen Tagen wird nicht versendet.
export const isWarmupWeekend = (ms) => { const d = new Date(ms).getDay(); return d === 0 || d === 6; };

// Erster Outreach-Werktag = erster Werktag am/ab Start.
export const warmupFirstWorkday = (startAt) => {
  let t = warmupStartOfDay(startAt);
  while (isWarmupWeekend(t)) t += WARMUP_MS_PER_DAY;
  return t;
};

// Werktags-Index (1-basiert) des Datums `ms`: Anzahl der Outreach-Werktage seit dem
// ersten Werktag bis einschließlich `ms`. An Wochenenden zählt der Wert des letzten
// Werktags (monoton steigend), vor dem Start 0.
export const warmupDayIndex = (startAt, ms) => {
  const day = warmupStartOfDay(ms);
  const first = warmupFirstWorkday(startAt);
  if (day < first) return 0;
  let count = 0;
  for (let t = first; t <= day; t += WARMUP_MS_PER_DAY) {
    if (!isWarmupWeekend(t)) count += 1;
  }
  return count;
};

// Kalenderdatum (ms) des n-ten Outreach-Werktags ab Start (für den Plan-Verlauf).
export const warmupWorkdayDate = (startAt, n) => {
  let t = warmupFirstWorkday(startAt);
  let count = 1;
  while (count < n) { t += WARMUP_MS_PER_DAY; if (!isWarmupWeekend(t)) count += 1; }
  return t;
};

export const fmtWarmupDate = (dk) => {
  if (!dk) return '';
  const [y, m, d] = String(dk).split('-').map(Number);
  if (!y) return dk;
  return new Date(y, m - 1, d).toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' });
};

// Datums-Key (YYYY-MM-DD) zurück in einen Zeitstempel (Tagesbeginn).
export const warmupDateKeyToMs = (dk) => {
  const [y, m, d] = String(dk).split('-').map(Number);
  if (!y) return Date.now();
  return new Date(y, m - 1, d).getTime();
};

// Langes Datum mit Wochentag (für den „nächster Tag"-Hinweis).
export const fmtWarmupDayLong = (ms) => new Date(ms).toLocaleDateString('de-DE', { weekday: 'long', day: '2-digit', month: '2-digit' });

// Wurde ein Tag verspätet eingetragen (nachgetragen)? = an einem späteren Kalendertag
// gespeichert als der eigentliche Outreach-Tag.
export const warmupSubmittedLate = (entry) => {
  if (!entry || !entry.submittedAt || !entry.dateKey) return false;
  return warmupStartOfDay(entry.submittedAt) > warmupDateKeyToMs(entry.dateKey);
};
